import { useMutation } from '@tanstack/react-query';

import { MUTATION_KEY } from '~common';
import { useInvalidatePinningQueries } from '~hooks';
import { postRequest } from '~services';
import { ICreatePinningRequestParams } from '~types';

export const useCreatePinningRequestMutation = () => {
  const { invalidatePinningQueries } = useInvalidatePinningQueries();

  const mutationFn = async (reqBody: ICreatePinningRequestParams) => {
    return postRequest({
      path: `api/venue-placement-mobile-pinning/create`,
      data: reqBody,
    }).then((res) => res.data);
  };

  return useMutation({
    mutationKey: [MUTATION_KEY.SUBMIT_PINNING_FORM],
    mutationFn,
    onSuccess: () => {
      invalidatePinningQueries();
    },
  });
};
